/* eslint-disable import/no-anonymous-default-export */
import requestOptions from './requestOptions'
import generalMapper from '../models/General_Mapper'
import apiValidation from '../validation/ApiRespValidation'

const getDepartamentos = async (parameters) => {
    try {
        const options = requestOptions.options('GET', parameters, '');
        const resp = await fetch(global.DEPARTAMENTOS, options);
        const data = await resp.json();
        const apiValidationResp = apiValidation.apiValidation(data);
        let response = [];
        if (!apiValidationResp.error) {
            response = generalMapper.selectMapper(data.data);
        } else {
            localStorage.clear();
            window.location.href = '/';
        }
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const statusProducts = async (parameters) => {
    try {
        const options = requestOptions.options('GET', parameters, '');
        const resp = await fetch(global.STATUS_PROD, options);
        const data = await resp.json();
        const apiValidationResp = apiValidation.apiValidation(data);
        let response = [];
        if (!apiValidationResp.error) {
            response = generalMapper.selectMapper(data.data);
        } else {
            localStorage.clear();
            window.location.href = '/';
        }
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const getCategoriaPorDepart = async (parameters, idDepartamento) => {
    try {
        const options = requestOptions.options('GET', parameters, '');
        const resp = await fetch(global.CAT_X_DEPAR + idDepartamento, options);
        const data = await resp.json();
        const apiValidationResp = apiValidation.apiValidation(data);
        let response = [];
        if (!apiValidationResp.error) {
            response = generalMapper.selectMapper(data.data);
        } else {
            localStorage.clear();
            window.location.href = '/';
        }
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const getTipoProdCategoria = async (parameters, idCategoria) => {
    try {
        const options = requestOptions.options('GET', parameters, '');
        const resp = await fetch(global.PROD_X_CAT + idCategoria, options);
        const data = await resp.json();
        const apiValidationResp = apiValidation.apiValidation(data);
        let response = [];
        if (!apiValidationResp.error) {
            response = generalMapper.selectMapper(data.data);
        } else {
            localStorage.clear();
            window.location.href = '/';
        }
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const getMarcaTipoProd = async (parameters, idTipoProd) => {
    try {
        const options = requestOptions.options('GET', parameters, '');
        const resp = await fetch(global.MARCA_X_TIPROD + idTipoProd, options);
        const data = await resp.json();
        const apiValidationResp = apiValidation.apiValidation(data);
        let response = [];
        if (!apiValidationResp.error) {
            response = generalMapper.selectMarcaModelMaterMapper(data.data);
        } else {
            localStorage.clear();
            window.location.href = '/';
        }
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const getTipoBodegaServices = async (parameters) => {
    try {
        const options = requestOptions.options('GET', parameters, '');
        const resp = await fetch(global.BODEGASTIPO, options);
        const data = await resp.json();
        const apiValidationResp = apiValidation.apiValidation(data);
        let response = [];
        if (!apiValidationResp.error) {
            response = generalMapper.selectMapper(data.data);
        } else {
            localStorage.clear();
            window.location.href = '/';
        }
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const getBodegaServices = async (parameters) => {
    try {
        const options = requestOptions.options('GET', parameters, '');
        const resp = await fetch(global.GETBODEGA, options);
        const data = await resp.json();
        const apiValidationResp = apiValidation.apiValidation(data);
        let response = [];
        if (!apiValidationResp.error) {
            response = generalMapper.selectMapper(data.data);
        } else {
            localStorage.clear();
            window.location.href = '/';
        }
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

export default {
    getDepartamentos,
    getCategoriaPorDepart,
    getTipoProdCategoria,
    getMarcaTipoProd,
    statusProducts,
    getTipoBodegaServices,
    getBodegaServices
}
